// extracted by mini-css-extract-plugin
export var printerCard = "_b6-1";
export var printerCardConfigured = "_b6-2";
export var printerCardError = "_b6-3";
export var printerCardsContainer = "_b6-0";
export var printerIcon = "_b6-8";
export var printerIconConfigured = "_b6-5";
export var printerIconContainer = "_b6-4";
export var printerIconError = "_b6-6";
export var printerIconUnconfigured = "_b6-7";
export var workstationsTableCard = "_b6-9";